import React from 'react';
import { Route, Routes, HashRouter } from 'react-router-dom';
import {LargeCenteredContainer} from "@eika/engine-view";
import { DefaultConfig } from './default-config';

import Avtale from './containers/Avtale/Avtale';
import BankIdInfo from './containers/BankIdInfo/BankIdInfo';

interface Props {
    config: typeof DefaultConfig;
}

export default (props: Props): React.ReactElement => {
    return (
        <LargeCenteredContainer>
            <HashRouter>
                <Routes>
                    <Route path="/" element={<BankIdInfo />} />
                    {/*<Route path="/" element={<Avtale {...props}/>} />*/}
                    <Route path="/aktivering" element={<Avtale {...props}/>} />
                </Routes>
            </HashRouter>
        </LargeCenteredContainer>
    );
};
